export const eyeCampDashboardTranslations = {
    en: {
        // Page
        pageTitle: "Eye Camp Dashboard",
        selectDistrict: "Select District",

        // Summary Cards
        totalCamps: "Total Camps",
        totalCampsSubtitle: "All eye-camp events",
        totalRegistrations: "Total Registrations",
        totalRegistrationsSubtitle: "Beneficiaries registered",
        beneficiariesScreening: "Beneficiaries / Screening",
        beneficiariesScreeningSubtitle: "Total beneficiaries screened",
        spectaclesDelivered: "Spectacles Delivered",
        spectaclesDeliveredSubtitle: "Glasses dispatched",
        surgeryDone: "Surgery Done",
        surgeryDoneSubtitle: "Completed surgeries",

        // Chart cards
        serviceTypes: "Service Types",
        serviceTypesSubtitle: "How many people received each type of help",
        serviceDetails: "Service Details at a Glance",
        serviceDetailsSubtitle: "Detailed overview of each service",
        totalServicesByAge: "Total Services by Age Group",
        totalServicesByAgeSubtitle: "Total services provided in each age group",
        totalServicesByGender: "Total Services by Gender",
        totalServicesByGenderSubtitle: "Total services provided for each gender",
        serviceStatusSummary: "Service Status Summary",
        ageGroup: "Age Group",
        ageRange: "Age Range",
        gender: "Gender",
        totalServices: "Total Services",
        all: "All",

        // Toggle
        chart: "Chart",
        table: "Table",

        // Loading
        loading: "Loading...",
        loadingAgeData: "Loading age data...",
        loadingGenderData: "Loading gender data...",
        loadingServiceStatus: "Loading service status...",

        // Service breakdown (status by service type)
        spectaclePending: "Spectacle Pending",
        spectacleDispatched: "Spectacle Dispatched",
        spectacleDelivered: "Spectacle Delivered",
        surgeryPending: "Surgery Pending",
        surgeryScheduled: "Surgery Scheduled",
        surgeryDoneLabel: "Surgery Done",
        diagnosticPending: "Diagnostic Pending",
        diagnosticScheduled: "Diagnostic Scheduled",
        diagnosticDone: "Diagnostic Done",
    },
    mr: {
        // Page
        pageTitle: "नेत्र शिबिर डॅशबोर्ड",
        selectDistrict: "जिल्हा निवडा",

        // Summary Cards
        totalCamps: "एकूण शिबिरे",
        totalCampsSubtitle: "सर्व नेत्र शिबिरे",
        totalRegistrations: "एकूण नोंदणी",
        totalRegistrationsSubtitle: "नोंदणीकृत लाभार्थी",
        beneficiariesScreening: "लाभार्थी / तपासणी",
        beneficiariesScreeningSubtitle: "एकूण तपासलेले लाभार्थी",
        spectaclesDelivered: "चष्मे वितरित",
        spectaclesDeliveredSubtitle: "चष्मे पाठवले",
        surgeryDone: "शस्त्रक्रिया पूर्ण",
        surgeryDoneSubtitle: "पूर्ण झालेल्या शस्त्रक्रिया",

        // Chart cards
        serviceTypes: "सेवांचा प्रकार",
        serviceTypesSubtitle: "कोणत्या प्रकारची मदत किती लोकांना मिळाली",
        serviceDetails: "सेवा तपशील: एक दृष्टीक्षेपात",
        serviceDetailsSubtitle: "प्रत्येक सेवेचा तपशीलवार आढावा",
        totalServicesByAge: "वयोगटानुसार एकूण सेवा",
        totalServicesByAgeSubtitle: "प्रत्येक वयोगटात पुरविलेल्या एकूण सेवा",
        totalServicesByGender: "लिंगानुसार एकूण सेवा",
        totalServicesByGenderSubtitle: "प्रत्येक लिंगासाठी पुरविलेल्या एकूण सेवा",
        serviceStatusSummary: "सेवा स्थिती सारांश",
        ageGroup: "वयोगट",
        ageRange: "वयोगट",
        gender: "लिंग",
        totalServices: "एकूण सेवा",
        all: "सर्व",

        // Toggle
        chart: "आलेख",
        table: "सारणी",

        // Loading
        loading: "लोड होत आहे...",
        loadingAgeData: "वय डेटा लोड होत आहे...",
        loadingGenderData: "लिंग डेटा लोड होत आहे...",
        loadingServiceStatus: "सेवा स्थिती लोड होत आहे...",

        // Service breakdown (status by service type)
        spectaclePending: "चष्मे प्रलंबित",
        spectacleDispatched: "चष्मे पाठवले",
        spectacleDelivered: "चष्मे वितरित",
        surgeryPending: "शस्त्रक्रिया प्रलंबित",
        surgeryScheduled: "शस्त्रक्रिया नियोजित",
        surgeryDoneLabel: "शस्त्रक्रिया पूर्ण",
        diagnosticPending: "निदान प्रलंबित",
        diagnosticScheduled: "निदान नियोजित",
        diagnosticDone: "निदान पूर्ण",
    },
};
